import React from 'react';
import {
  FlexCol,
  BodyTextLarge,
  H3Text,
  BodyTextSmall,
  PaywallButton,
  H2Text,
  BasicContainer,
  FlexRow,
} from '@minecraft.atoms';
import IconWithErrorBoundary from '@minecraft.icon';
import { CountdownTimer } from '@minecraft.molecules';
import { getCurrentDateTime } from '@minecraft.date-utils';
import { Trans, useTranslation } from '../../../../I18N';
import { DiscountModalProps } from '../useDiscountHook';

export const TargetAnnualOnDiscountedM2M = ({
  billedText,
  discountedPlan,
  onCTAClick,
  annualPrice,
  originalPrice,
  price,
  subscription,
}: DiscountModalProps) => {
  const { t, formatIntlDate } = useTranslation();

  const planFeatures = [
    'common:paywall.features.premium.unlimitedSubmissionsAndMedia',
    'common:paywall.features.premium.talentScout',
    'common:paywall.features.premium.trackEverySubmissions',
    'common:paywall.features.premium.connectSocial',
  ];

  return (
    <FlexCol justifyItems="center" alignItems="center" gap="6" w="full" mt="8" mb="4">
      <IconWithErrorBoundary name="discount-asset" />
      <H2Text fontWeight="bold" as="span" align="center" testId="target-annual-discount">
        <Trans
          i18nKey="common:paywall.plan.targetAnnualDiscountOffer"
          components={[<H2Text fontWeight="bold" color="discountHighlight" as="span" />]}
          values={{
            discountPercent: discountedPlan?.discountPercent,
          }}
        />
      </H2Text>
      <CountdownTimer endsAt={subscription?.expirationDate} />
      <FlexCol w="full" justifyItems="center" alignItems="center" gap="2">
        <BodyTextLarge
          fontWeight="medium"
          as="span"
          textWrap="balance"
          align="center"
          testId="target-annual-price-section"
        >
          <Trans
            i18nKey="common:paywall.plan.retain_premium_discount"
            components={[
              <BodyTextLarge fontWeight="medium" color="disabled" className="cn_line-through" as="span" />,
              <H3Text fontWeight="bold" color="discountHighlight" as="span" />,
            ]}
            values={{
              originalPrice,
              price,
            }}
          />
        </BodyTextLarge>
        <BodyTextSmall color="disabled">{billedText}</BodyTextSmall>
        <BodyTextSmall color="disabled" align="center">
          {t('common:paywall.plan.charged_on', {
            price: annualPrice,
            date: formatIntlDate({ date: getCurrentDateTime(), format: 'MONTH_DAY_YEAR' }),
          })}
        </BodyTextSmall>
      </FlexCol>
      <FlexCol w="full" gap="4" mdProps={{ w: '2/3' }}>
        {planFeatures?.map((feature) => (
          <FlexRow gap="3" alignItems="start" w="full" key={feature}>
            <IconWithErrorBoundary name="check-circle" themeColor="discountOffer" />
            <BasicContainer w="4/5">
              <BodyTextSmall textWrap="balance">
                <Trans i18nKey={feature} components={[<b />]} />
              </BodyTextSmall>
            </BasicContainer>
          </FlexRow>
        ))}
        <PaywallButton
          label={t('common:paywall.plan.discount.confirm_reactivation')}
          color="discount"
          onClick={onCTAClick}
          full
          isSmall
        />
      </FlexCol>
    </FlexCol>
  );
};
